import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {Location} from '@angular/common';
import {AlertService} from '../_services';
import {ImageSize, Cycle, CampaignProduct, ProductBase, Product, getProductImageUrl} from "../_models";
import {Form} from '../_forms';
import {NgxSmartModalService} from "ngx-smart-modal";

@Component({
  moduleId: module.id.toString(),
  templateUrl: './cycle.component.html',
  selector: 'cycles',
  styleUrls: [
    '../image/image.component.css'
  ]
})
export class CycleComponent extends Form implements OnInit, OnChanges {
  selectedCycleIndex: number;
  selectedCycle: Cycle;
  selectedProduct: ProductBase;

  @Input('product') campaignProduct: CampaignProduct;
  @Output('saveProduct') onSaveProductEmitter = new EventEmitter();

  constructor(
    protected router: Router,
    protected location: Location,
    private modalService: NgxSmartModalService,
    protected alertService: AlertService
  ) {
    super(alertService, router, location);
  }

  ngOnInit() {
    this.updateForm();
    super.ngOnInit();
  }

  ngOnChanges(): void {
    this.updateForm();
  }

  private updateForm() {
    this.selectedCycle = null;
  }

  getCycleProduct(cycle: Cycle) {
    return cycle.product || this.campaignProduct.product;
  }

  getCycleImageUrl(cycle: Cycle) {
    return getProductImageUrl(this.getCycleProduct(cycle), ImageSize.original);
  }

  getCycleName(cycle: Cycle) {
    const product = this.getCycleProduct(cycle);
    return `${cycle.display_name || product.name} (${product.product_id})`;
  }

  edit(cycleIndex: number) {
    this.selectedCycleIndex = cycleIndex;
    this.selectedCycle = this.campaignProduct.cycles[this.selectedCycleIndex];
    this.openEditDialog();
  }

  protected openEditDialog() {
    this.modalService.getModal('cycleDialog').open();
  }

  onSaveCycle(cycle: Cycle) {
    cycle.product = this.selectedCycle.product;
    cycle.combination = this.selectedCycle.combination;
    this.modalService.getModal('cycleDialog').close();
    Object.assign(this.campaignProduct.cycles[this.selectedCycleIndex], cycle);
    this.selectedCycle = null;
  }

  editProduct(cycle: Cycle) {
    this.selectedProduct = this.getCycleProduct(cycle);
    this.modalService.getModal('editProductDialog').open();
  }

  onSaveProduct(product: Product) {
    if (this.campaignProduct.product.id === product.id) {
      this.campaignProduct.product = product;
      this.onSaveProductEmitter.emit(product);
    }
    this.campaignProduct.cycles.forEach((cycle: Cycle) => {
      if (cycle.product && cycle.product.id === product.id) {
        cycle.product = product;
      }
      if (cycle.combination && cycle.combination.id === product.id) {
        cycle.combination = product;
      }
    });
    this.modalService.getModal('editProductDialog').close();
    this.selectedProduct = null;
  }
}
